import { CampaignProductsStatistics } from "../../../models/Statistics";

export const REQUEST_CAMPAIGNPRODUCTSTATISTICS =
  "REQUEST_CAMPAIGNPRODUCTSTATISTICS";
export const REQUEST_CAMPAIGNPRODUCTSTATISTICS_DONE =
  "REQUEST_CAMPAIGNPRODUCTSTATISTICS_DONE";
export const REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS =
  "REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS";
export const REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS_DONE =
  "REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS_DONE";

export interface FetchCampaignProductsStatistics {
  type: typeof REQUEST_CAMPAIGNPRODUCTSTATISTICS;
  payload: ReadonlyArray<CampaignProductsStatistics>;
}

export interface FetchCampaignProductsStatisticsDone {
  type: typeof REQUEST_CAMPAIGNPRODUCTSTATISTICS_DONE;
  payload: ReadonlyArray<CampaignProductsStatistics>;
}

export interface FetchCampaignComparisonProductsStatistics {
  type: typeof REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS;
  payload: ReadonlyArray<CampaignProductsStatistics>;
}

export interface FetchCampaignComparisonProductsStatisticsDone {
  type: typeof REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS_DONE;
  payload: ReadonlyArray<CampaignProductsStatistics>;
}

export interface CampaignProductsStatisticsState {
  isLoading: boolean;
  isLoadingCompare: boolean;
  campaignProductsStatistics: ReadonlyArray<CampaignProductsStatistics>;
  campaignComparisonProductStatistics: ReadonlyArray<CampaignProductsStatistics>;
}

export type CampaignProductsStatisticsActions =
  | FetchCampaignProductsStatistics
  | FetchCampaignProductsStatisticsDone
  | FetchCampaignComparisonProductsStatistics
  | FetchCampaignComparisonProductsStatisticsDone;
